// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1MbIK","left":"StickyBox_left__2Vw92","right":"StickyBox_right__3V0tq"};